<div *ngIf="spinner.isShowing" class="loading-spinner-modal"
     [class.loading-spinner-modal--iframe-embed]="iframeEmbed.isIframeEmbed">
  <div class="loading-spinner text-success">
    <sk-iframe-embed-loading *ngIf="iframeEmbed.isIframeEmbed" [scale]="3"></sk-iframe-embed-loading>
    <g sk-animated-cart-spinner *ngIf="!iframeEmbed.isIframeEmbed" [scale]="3"></g>
    <div class="loading-spinner-message" *ngIf="spinner.message && !iframeEmbed.isIframeEmbed">{{spinner.message}}</div>
  </div>
</div>